import i18n from "i18next";

/**
 * @param variable {string}
 * @param [args] {{[key:string]: string|number}}
 * @returns {string}
 */
export function translate(variable, args) {
  return i18n.t("translations:" + variable, args);
}
